export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9774_START_DATE_': 'Start Date:',
    '_73_END_DATE_': 'End Date'
};
